import React, {useContext} from "react";
import { css } from "emotion";
import { colors, boxStyles } from "../../styles/theme";
import InfoTitle from "../InfoTitle";
import CircleAddButton from "../CircleAddButton";
import {GlobalContext} from "../../context/GlobalState";

const AddRow = () => {
  const {currentWorkspace} = useContext(GlobalContext);
  return (
    <div className={container}>
      <InfoTitle title={currentWorkspace ? `${currentWorkspace.name}` : 'My Spotlights'} hideWorkspaceName />
      <CircleAddButton />
    </div>
  );
};

export default AddRow;

const container = css`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${boxStyles.standardPadding};

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    border-bottom: 2px solid ${colors.inputBackground};
    margin-top: 0;
    margin-bottom: 20px;
    padding: 0;
  }
`;
